const ANALYTICS_HOSTS = [
  "customer.io",
  "customeriomail.com",
  "customeriotrk.com",
  "mixpanel.com",
  "google-analytics.com",
  "googletagmanager.com",
  "analytics.google.com",
  "hotjar.com",
  "hotjar.io",
  "sentry.io",
  "intercom.io",
  "intercomcdn.com",
  "doubleclick.net",
  "facebook.com/tr",
  "segment.io",
  "segment.com"
];

export const shouldCreateSpanForRequest = (url: string): boolean => {
  try {
    const { hostname } = new URL(url, window.location.origin);
    return !ANALYTICS_HOSTS.some((h) => hostname.includes(h));
  } catch {
    return true;
  }
};
